export const Reset = () => {
  return (
    <svg viewBox="0 0 24 24" height="24" width="24" fill="none">
      <path
        d="m15.35 9.49-.064-6.213 6.212-.063M5.487 5.598a9.016 9.016 0 0 0-1.793 2.436M10.387 3.163a9.011 9.011 0 0 0-2.19.629M2.732 11.948a9.022 9.022 0 0 0 .455 2.99"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.273 18.386A9.043 9.043 0 1 0 17.728 5.293l-1.702-1.489"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
